import store from '@/state/store'
import AccessLevels from '../components/roles/access-levels'

import authStorageService from '@/services/auth/auth-storage.service.js';

export default [{
    path: '*',
    name: '404',
    meta: {
        authRequired: true,
    },
    component: () =>
        import('../views/pages/utility/error-404')
},
{
    path: '/login',
    name: 'login',
    component: () =>
        import('../views/pages/account/login'),
    meta: {
        beforeResolve(routeTo, routeFrom, next) {
            // Check if user is already logged in by checking localStorage
            const loggeduser = authStorageService.getAccessToken();
            if (loggeduser) {
                // Prevent navigation loop - only redirect if not already on home
                if (routeTo.name === 'home') {
                    next();
                } else {
                    next({ name: 'home' });
                }
            } else {
                next();
            }
        },
    },
},

{
    path: '/unauthorized',
    name: 'Access Denied',
    component: () =>
        import('../views/pages/account/unauthorised'),
    meta: {
        authRequired: false,
    },
},

{
    path: '/error',
    name: 'ErrorBoundary',
    component: () =>
        import('../components/errors/ErrorBoundary'),
    meta: {
        authRequired: false,
    },
    props: route => ({
        error: route.params.error,
        errorInfo: route.params.errorInfo
    })
},

{
    path: '/global-error',
    name: 'GlobalError',
    component: () =>
        import('../components/errors/ErrorBoundary'),
    meta: {
        authRequired: false,
    },
    props: route => ({
        error: route.params.error,
        errorInfo: route.params.errorInfo
    })
},

{
    path: '/error-test',
    name: 'Error Test',
    component: () =>
        import('../views/pages/utility/error-test'),
    meta: {
        authRequired: false,
    },
},

{
    path: '/password-reset',
    name: 'Password Reset',
    component: () =>
        import('../views/pages/account/password-reset'),
    meta: {
        beforeResolve(routeTo, routeFrom, next) {
            // Check if user is already logged in by checking localStorage
            const loggeduser = authStorageService.getAccessToken();
            if (loggeduser) {
                next({ name: 'home' })
            } else {
                next()
            }
        },
    },
},

{
    path: '/forgot-password',
    name: 'Forgot-password',
    component: () =>
        import('../views/pages/account/forgot-password'),
    meta: {
        beforeResolve(routeTo, routeFrom, next) {
            // Check if user is already logged in by checking localStorage
            const loggeduser = authStorageService.getAccessToken();
            if (loggeduser) {
                next({ name: 'home' })
            } else {
                next()
            }
        },
    },
},

{
    path: '/login/verify-otp',
    name: 'Verify OTP',
    component: () =>
        import('../views/pages/account/verify-otp'),
    meta: {
        authRequired: false,
        beforeResolve(routeTo, routeFrom, next) {
            // Check if user is already logged in
            const loggeduser = authStorageService.getAccessToken();
            if (loggeduser) {
                next({ name: 'home' });
            } else {
                // Check if there is pending auth (user came from login page)
                const pendingAuth = authStorageService.getPendingAuth();
                if (!pendingAuth || !pendingAuth.username) {
                    // No pending auth, redirect to login
                    next({ name: 'login' });
                } else {
                    next();
                }
            }
        },
    },
},

// Activate AGENT Account
{
    path: '/verify-agent/:token',
    name: 'Set Agent Password',
    authRequired: false,
    component: () =>
        import('../views/pages/account/activate.vue'),
    meta: {
        beforeResolve(routeTo, routeFrom, next) {
            // Check if user is not logged in by checking localStorage
            const loggeduser = authStorageService.getAccessToken();
            if (!loggeduser) {
                next()
            }
        },
    }

},
// ACTIVE CUSTOMER ACCOUNT
{
    path: '/verify/:token',
    name: 'Set Customer Password',
    authRequired: false,
    component: () =>
        import('../views/pages/account/activateCustomer.vue'),
    meta: {
        beforeResolve(routeTo, routeFrom, next) {
            // Check if user is not logged in by checking localStorage
            const loggeduser = authStorageService.getAccessToken();
            if (!loggeduser) {
                next()
            }
        },
    }

},

{
    path: '/logout',
    name: 'logout',
    meta: {
        authRequired: false,
        beforeResolve(routeTo, routeFrom, next) {

            store.dispatch('authservice/logout')

            // Simply redirect to login after logout
            next({ name: 'login' })
        },
    },
},
{
    path: '/',
    name: 'home',
    meta: {
        authRequired: true,
        roles: AccessLevels.ALLOW_ALL
    },
    component: () =>
        import('../views/pages/landing-page/index')
}
    , {
    path: '/Get-Started',
    name: 'Get Started',
    meta: {
        authRequired: true,
        roles: AccessLevels.ALLOW_ALL
    },
    component: () =>
        import('../views/pages/landing-page/index')
}
    ,
{
    path: '/ServicesManagement/control-panel',
    name: 'Services Dashboard',
    meta: {
        authRequired: true,
        roles: AccessLevels.HQ_STAFF_ONLY
    },
    component: () =>
        import('../views/pages/services-dashboard/index')
},

{
    path: '/TellerDashboard/home',
    name: 'Teller Dashboard',
    meta: {
        authRequired: true,
        roles: AccessLevels.ALLOW_ALL
    },
    component: () =>
        import('../views/pages/dashboard/teller-dashboard/index')
},

{
    path: '/modern-dashboard',
    name: 'Modern Dashboard',
    meta: {
        authRequired: true,
        roles: AccessLevels.ALLOW_ALL
    },
    component: () =>
        import('../views/pages/dashboard/modern-dashboard')
},

//REMITTANCES
{
    path: '/Remittances/Send-Receive-Reverse',
    name: 'Wiremit Remittances',
    meta: {
        authRequired: true,
        roles: AccessLevels.BRANCH_STAFF_ONLY

    },
    component: () =>
        import('../views/pages/remittances/remittances')
},

{
    path: '/remittances/reversals',
    name: 'Transaction Reversal',
    meta: {
        authRequired: true,
        roles: AccessLevels.AGENT_STAFF_ONLY

    },
    component: () =>
        import('../views/pages/remittances/authoriseReversal')
},


//SHOP MANAGEMENT
{
    path: '/shops',
    name: 'Agent Shops',
    meta: {
        authRequired: true,
        roles: AccessLevels.AGENT_STAFF_ONLY
    },
    component: () =>
        import('../views/pages/shops/shops')
},




//ACCOUNT MANAGEMENT
{
    path: '/global/system-accounts',
    name: 'System Wallets',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/accounts/control-accounts.vue')
},
{
    path: '/global/tax-accounts',
    name: 'Tax Accounts',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/account-management/accounts')
},
{
    path: '/global/commissions-accounts',
    name: 'Commissions Accounts',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/account-management/accounts')
},
{
    path: '/global/Organisation Funding',
    name: 'Organisation Funding',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/account-management/accounts')
},
{
    path: '/global/organisation-accounts',
    name: 'Global Organisation Accounts',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/accounts/organisation-accounts.vue')
},
{
    path: '/global/customer-deposits-accounts',
    name: 'Customer Deposits Accounts',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/account-management/accounts')
},

{
    path: '/manage-accounts/create-control-accounts',
    name: 'System Control Accounts',
    meta: { authRequired: true, roles: AccessLevels.AGENT_STAFF_ONLY },
    component: () =>
        import('../views/pages/account-management/accounts')
},
{
    path: '/manage-accounts/funds-transfer',
    name: 'Transfer Funds across accounts',
    meta: { authRequired: true, roles: AccessLevels.SUPER_ADMINS_ONLY },
    component: () =>
        import('../views/pages/account-management/fundsTransfer')
},

//ADVERTISEMENT MANAGEMENT
{
    path: '/Promotions/system-notifications',
    name: 'Manage Advertisements',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/advertisements/manage-advertisements')
},

//Vault Management
{
    path: '/admin/agent-funding',
    name: 'agent-funding',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/vault/org-vault-funding')
},
{
    path: '/branch/branch-funding',
    name: 'branchfunding',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/vault/branch-vault-funding')
},
{
    path: '/branch/close-branch-vault',
    name: 'closevault',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/vault/close-branch-vault')
},

{
    path: '/till/till-funding',
    name: 'tillfunding',
    meta: { authRequired: true, roles: AccessLevels.AGENT_STAFF_ONLY },
    component: () =>
        import('../views/pages/vault/till-funding')
},

{
    path: '/till/teller-till',
    name: 'closetill',
    meta: { authRequired: true, roles: AccessLevels.BRANCH_STAFF_ONLY },
    component: () =>
        import('../views/pages/vault/teller-till')
},

{
    path: '/till/authorisation',
    name: 'authorise till closure',
    meta: { authRequired: true, roles: AccessLevels.BRANCH_STAFF_ONLY },
    component: () =>
        import('../views/pages/vault/authoriseClosure')
},

{
    path: '/TellerAuthorisations/till/authorisation',
    name: 'acknowledge funding',
    meta: { authRequired: true, roles: AccessLevels.BRANCH_STAFF_ONLY },
    component: () =>
        import('../views/pages/vault/acknowledgeFunding')
},
{
    path: '/Teller-Reports/transaction-reports',
    name: 'Teller Transaction Report',
    meta: { authRequired: true, roles: AccessLevels.BRANCH_STAFF_ONLY },
    component: () =>
        import('../views/pages/teller/teller-transaction-reports.vue')
},
{
    path: '/Teller-Reports/activity-report',
    name: 'Teller Activity Report',
    meta: { authRequired: true, roles: AccessLevels.BRANCH_STAFF_ONLY },
    component: () =>
        import('../views/pages/teller/auditReports.vue')
},


//USER MANAGEMENT
{
    path: '/users/registration',
    name: 'User Registration',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/user-management/registration')
},
{
    path: '/users',
    name: 'View Users',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/user-management/userlist')
},

// REPORTS

/* 
    HQ GLOBAL REPORTS

*/    
{
    path: '/HQ-Reports/performance-insights',
    name: 'Perfomance Insights Summary',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/reports/global-summary.vue')
},
{
    path: '/HQ-Reports/Executive Dashboard',
    name: 'Executive Dashboard',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/reports/executive-dashboard.vue')
},
{
    path: '/HQ-Reports/executive-summary',
    name: 'Financial Executive Dashboard',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/reports/executive-dashboard.vue')
},
{
    path: '/HQ-Reports/user-audit-report',
    name: 'User Audit Report',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/reports/userAudit/userAuditReport')
},
{
    path: '/HQ-Reports/Organisations Report',
    name: 'Organisation Summary Report',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/reports/organisation-based-report.vue')
},
{
    path: '/HQ-Reports/RBZ Submission Reports',
    name: 'RBZ Submission Reports',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/reports/rbz-submissions-report.vue')
},
{
    path: '/HQ-Reports/Transaction Reports',
    name: 'Transaction Reports',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/reports/transaction-report.vue')
},
{
    path: '/HQ-Reports/transaction-reports',
    name: 'HQ Transaction Reports',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/reports/hq-transaction-reports.vue')
},
{
    path: '/HQ-Reports/Users-Reports',
    name: 'Users Reports',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/reports/users-report.vue')
},

{
    path: '/HQ-Reports/Remittances-Reports',
    name: 'Remittance Report',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/reports/transaction-report.vue')
},

{
    path: '/HQ-Reports/Initiations-Reports',
    name: 'Initiations Reports',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/reports/initiations-report.vue')
},
{
    path: '/HQ-Reports/Authorisation-Reports',
    name: 'Authorisation Reports',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/reports/authorizations-report.vue')
},
{
    path: '/GlobalReports/Users-Reports',
    name: 'User Reports',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/reports/global-users-report.vue')
},




/*
    AGENT REPORTS (Meant for OrgStaff)

    - AGENT SUMMARY REPORT 
        - Org Wallet Balance Commissions Balance,
        - List or Branches and Account Balances
        - Deposited total
        - Collected total
        - Awaiting collection total
        - Revenue
    - Organisations transactions 
        (all branches, all tellers, filters)
    - Sub Agent Report
        per SubAgent Summary
    - Users Report
    - Organisation Wallet Statement



*/

{
    path: '/AgentsInsights/performance-insights',
    name: 'Agent Performance Insights Summary',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/reports/global-summary.vue')
}, 
{
    path: '/AgentsInsights/executive-summary',
    name: 'Agent Financial Executive Dashboard',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/reports/executive-dashboard.vue')
},

{
    path: '/Agent-Reports/remittances-reports',
    name: 'Remittances Report',
    meta: { authRequired: true, roles: AccessLevels.AGENT_STAFF_ONLY },
    component: () =>
        import('../views/pages/Agent/reports/agent-transaction-reports.vue')
},

{
    path: '/Agent-Authorisations/Close Till Authorisations',
    name: 'Remittance Authorisations Report',
    meta: { authRequired: true, roles: AccessLevels.AGENT_STAFF_ONLY },
    component: () =>
        import('../views/pages/Agent/authorisations/remittance-authorisations.vue')
},

{
    path: '/Branch-Authorisations/Remittance Authorisation',
    name: 'authorise branch remittances',
    meta: { authRequired: true, roles: AccessLevels.BRANCH_STAFF_ONLY },
    component: () =>
        import('../views/pages/vault/acknowledge-branch-funding.vue')
},


//vault
{
    path: '/Agent-Vault/Fund Branch',
    name: 'Fund Branch',
    meta: { authRequired: true, roles: AccessLevels.AGENT_STAFF_ONLY },
    component: () =>
        import('../views/pages/Agent/vault/fund-branch.vue')
},
{
    path: '/Agent-Vault/liquidate-branch',
    name: 'Liquidate Branch',
    meta: { authRequired: true, roles: AccessLevels.AGENT_STAFF_ONLY },
    component: () =>
        import('../views/pages/Agent/vault/liquidate-branch.vue')
},
{
    path: '/Agent-Wallets/Manage Accounts',
    name: 'Agent Wallet Accounts',
    meta: { authRequired: true, roles: AccessLevels.AGENT_STAFF_ONLY },
    component: () =>
        import('../views/pages/Agent/accounts/organisation-accounts.vue')
},



/* 
    BRANCH REPORTS
    - Transactions Report
        - All Tellers OF THAT BRANCH , filters
    - Users Report
    - Branch Wallet Statement

*/    

{
    path: '/Branch-Vault/Liquidate Teller',
    name: 'Branch Liquidate Teller',
    meta: { authRequired: true, roles: AccessLevels.BRANCH_STAFF_ONLY },
    component: () =>
        import('../views/pages/vault/close-branch-vault')
},
{
    path: '/Branch-vault/fund-teller',
    name: 'Branch Fund Teller',
    meta: { authRequired: true, roles: AccessLevels.BRANCH_STAFF_ONLY },
    component: () =>
        import('../views/pages/vault/till-funding')
},

{
    path: '/Branch-Reports/balances',
    name: 'Organisation Accounts',
    meta: { authRequired: true, roles: AccessLevels.BRANCH_STAFF_ONLY },
    component: () =>
        import('../views/pages/Branch/accounts/organisation-accounts.vue')
},
// Branch Admin (supervisor) reports - consolidated for every user in the admin's own branch
{
    path: '/Branch-Reports/transaction-reports',
    name: 'Branch Admin Transaction Reports',
    meta: { authRequired: true, roles: AccessLevels.BRANCH_ADMIN_ONLY },
    component: () =>
        import('../views/pages/Branch/reports/branch-admin-transaction-reports.vue')
},
{
    path: '/Branch-Reports/user-audit-report',
    name: 'Branch Admin User Audit Report',
    meta: { authRequired: true, roles: AccessLevels.BRANCH_ADMIN_ONLY },
    component: () =>
        import('../views/pages/Branch/reports/branch-admin-user-audit-report.vue')
},
{
    path: '/Branch-Reports/remittances-reports',
    name: 'Branch Remittances Report',
    meta: { authRequired: true, roles: AccessLevels.BRANCH_STAFF_ONLY },
    component: () =>
        import('../views/pages/Branch/reports/transaction-report.vue')
},
/* 
    TELLER REPORTS
    - Wallet Balance
    - Transactions Report
    - Wallet Statement
*/

{
    path: '/reports/remittances',
    name: 'Global Remittances Report',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/reports/remittanceReports')
},
{
    path: '/reports/account-balances',
    name: 'Account Balances Report',
    meta: { authRequired: true,  roles: AccessLevels.ALLOW_ALL },
    component: () =>
        import('../views/pages/reports/accountBalancesReport')
},
{
    path: '/reports/account-balances/:accountId',
    name: 'Account Balance Details',
    meta: { authRequired: true, roles: AccessLevels.ALLOW_ALL },
    component: () =>
        import('../views/pages/reports/account-balance-detail')
},
// Original wallet statement route - kept for backward compatibility
{
    path: '/wallets/:walletId/statement',
    name: 'Wallet Statement Details',
    meta: { authRequired: true, roles: AccessLevels.ALLOW_ALL },
    component: () =>
        import('../views/pages/wallets/wallet-statement-detail')
},

// New permission-based wallet statement routes
{
    path: '/hq/wallet-statement/:accountId?',
    name: 'HQ Wallet Statement',
    meta: { 
        authRequired: true, 
        roles: AccessLevels.HQ_STAFF_ONLY 
    },
    component: () =>
        import('../views/pages/wallets/hq-wallet-statement')
},
{
    path: '/organization/wallet-statement/:accountId?',
    name: 'Organization Wallet Statement',
    meta: { 
        authRequired: true, 
        roles: AccessLevels.ALL_ADMINS_ONLY 
    },
    component: () =>
        import('../views/pages/wallets/organization-wallet-statement')
},
{
    path: '/branch/wallet-statement/:accountId?',
    name: 'Branch Wallet Statement',
    meta: { 
        authRequired: true, 
        roles: AccessLevels.ALL_STAFF 
    },
    component: () =>
        import('../views/pages/wallets/branch-wallet-statement')
},
{
    path: '/personal/wallet-statement/:accountId?',
    name: 'Personal Wallet Statement',
    meta: { 
        authRequired: true, 
        roles: AccessLevels.BRANCH_STAFF_ONLY 
    },
    component: () =>
        import('../views/pages/wallets/personal-wallet-statement')
},
{
    path: '/reports/customers',
    name: 'Customer Report',
    meta: { authRequired: true },
    component: () =>
        import('../views/pages/reports/customerReports')
},
{
    path: '/Agent-Reports/user-audit-report',
    name: 'Admin User Audit Report',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/reports/userAudit/userAuditReport')
},
{
    path: '/Agent-Reports/transaction-reports',
    name: 'Agent Transactional Report',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/Agent/reports/agent-transaction-reports.vue')
},

// System Configuration
{
    path: '/business-conditions',
    name: 'Business Configuration',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/system-configurations/businessConditionsConfig')
},

{
    path: '/alerts',
    name: 'Alerts Configuration',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/system-configurations/alertConfigs')
},

{
    path: '/roles',
    name: 'Role Configs',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/system-configurations/roleConfig')
},

{
    path: '/promotions',
    name: 'Configure Promotions',
    meta: { authRequired: true, roles: AccessLevels.HQ_STAFF_ONLY },
    component: () =>
        import('../views/pages/promotions/manage-promos')
},


//HQ ADMIN FUNCTIONS
{
    path: '/admin/home',
    name: 'Home',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/home/index')
},
{
    path: '/admin/manage-organizations',
    name: 'Manage Organizations',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/manage-organizations/organizations')
},
{
    path: '/admin/detailed-single-organization/:organizationID',
    name: 'Admin Expand Single Organization',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/manage-organizations/single-organizations')
},
{
    path: '/admin/detailed-single-branch/:organizationID/:branchID',
    name: 'Admin Expand Single Branch',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/manage-organizations/single-branch')
},
{
    path: '/admin/org/users',
    name: 'Manage organization users',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/manage-organizations/org-users')
},


//ORG ADMIN FUNCTIONS :AGENT_STAFF_ONLY
{
    path: '/org_admin/manage-organisation',
    name: 'Manage Organisation',
    meta: { authRequired: true, roles: AccessLevels.AGENT_STAFF_ONLY },
    component: () =>
        import('../views/pages/Agent/manage-organizations/single-organizations')
},

{
    path: '/org_admin/detailed-single-organization/:organizationID',
    name: 'Expand Single Organization',
    meta: { authRequired: true, roles: AccessLevels.AGENT_STAFF_ONLY },
    component: () =>
        import('../views/pages/Agent/manage-organizations/single-organizations')
},
{
    path: '/org_admin/detailed-single-branch/:organizationID/:branchID',
    name: 'Expand Single Branch',
    meta: { authRequired: true, roles: AccessLevels.AGENT_STAFF_ONLY },
    component: () =>
        import('../views/pages/Agent/manage-organizations/single-branch')
},

{
    path: '/org_admin/manage-subagents',
    name: 'Manage Subagents',
    meta: { authRequired: true, roles: AccessLevels.AGENT_STAFF_ONLY },
    component: () =>
        import('../views/pages/Agent/manage-organizations/single-organizations')
},
{
    path: '/org_admin/manage-branches',
    name: 'Manage Branches',
    meta: { authRequired: true, roles: AccessLevels.AGENT_STAFF_ONLY },
    component: () =>
        import('../views/pages/Agent/manage-organizations/single-organizations')
},
{
    path: '/org_admin/manage-users',
    name: 'Manage Users',
    meta: { authRequired: true, roles: AccessLevels.AGENT_STAFF_ONLY },
    component: () =>
        import('../views/pages/Agent/manage-organizations/users')
},
{
    path: '/agent/authorisations',
    name: 'authorise agent funding',
    meta: { authRequired: true, roles: AccessLevels.AGENT_STAFF_ONLY },
    component: () =>
        import('../views/pages/Agent/authorisations/authorisation')
},
{
    path: '/org_admin/fund-branch',
    name: 'Branch Funds Transfer',
    meta: { authRequired: true, roles: AccessLevels.AGENT_STAFF_ONLY },
    component: () =>
        import('../views/pages/Agent/account-management/branchFunding')
},

{
    path: '/agent-report/user-audit-report',
    name: 'Agent User Audit Report',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/Agent/reports/users-report.vue')
},



//TEMPLATE
{
    path: '/pages/faqs',
    name: 'Faqs',
    meta: { authRequired: false },
    component: () =>
        import('../views/pages/utility/faqs')
},

{
    path: '/pages/error-404',
    name: 'Error-404',
    meta: { authRequired: false },
    component: () =>
        import('../views/pages/utility/error-404')
},
{
    path: '/pages/error-500',
    name: 'Error-500',
    meta: { authRequired: true },
    component: () =>
        import('../views/pages/utility/error-500')
},


{
    path: '/charts/apex',
    name: 'Apex chart',
    meta: { authRequired: true },
    component: () =>
        import('../views/pages/charts/apex')
},
{
    path: '/charts/chartjs',
    name: 'Chartjs chart',
    meta: { authRequired: true },
    component: () =>
        import('../views/pages/charts/chartjs/index')
},
{
    path: '/charts/chartist',
    name: 'Chartist chart',
    meta: { authRequired: true },
    component: () =>
        import('../views/pages/charts/chartist')
},







/*3RD PARTY SERVICES

    HQ ACCESS ONLY 

*/

{
    path: '/mesta/manage-senders',
    name: 'View Mesta Senders',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/Mesta/viewSenderReport.vue')
},
{
    path: '/mesta/sender-detail/:senderId',
    name: 'Sender Detail',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/Mesta/senderDetail.vue')
},
{
    path: '/mesta/manage-beneficiaries',
    name: 'Manage Beneficiaries',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/Mesta/manageBeneficiaries.vue')
},
{
    path: '/mesta/beneficiary-detail/:beneficiaryId',
    name: 'Beneficiary Detail',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/Mesta/beneficiaryDetail.vue')
},
{
    path: '/mesta/banks',
    name: 'Mesta Banks',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/Mesta/banks.vue')
},
{
    path: '/mesta/manage-ubo',
    name: 'Manage UBO',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/Mesta/manageUbo.vue')
},
{
    path: '/mesta/validation-rules',
    name: 'Validation Rules',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/Mesta/validationRules.vue')
},
{
    path: '/mesta/documents',
    name: 'Mesta Documents',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/Mesta/documents.vue')
},
{
    path: '/mesta/ubo-detail/:uboId',
    name: 'UBO Detail',
    meta: { authRequired: true, roles: AccessLevels.ALL_ADMINS_ONLY },
    component: () =>
        import('../views/pages/HeadQuarters/Mesta/uboDetail.vue')
},

// Developer Documentation Routes (Public)
{
    path: '/developer-docs',
    component: () => import('../views/pages/developer-documentation/DeveloperDocumentation.vue'),
    meta: { authRequired: false },
    children: [
        {
            path: '',
            name: 'developer-docs-home',
            meta: { authRequired: false },
            component: () => import('../views/pages/developer-documentation/Home.vue')
        },
        {
            path: 'getting-started',
            name: 'getting-started',
            meta: { authRequired: false },
            component: () => import('../views/pages/developer-documentation/GettingStarted.vue')
        },
        {
            path: 'api-reference',
            name: 'api-reference',
            meta: { authRequired: false },
            component: () => import('../views/pages/developer-documentation/ApiReference.vue')
        },
        {
            path: 'api-reference/quick-setup',
            name: 'quick-setup',
            meta: { authRequired: false },
            component: () => import('../views/pages/developer-documentation/QuickSetup.vue')
        },
        {
            path: 'api-reference/pagination',
            name: 'pagination',
            meta: { authRequired: false },
            component: () => import('../views/pages/developer-documentation/Pagination.vue')
        },
        {
            path: 'cars/introduction',
            name: 'cars-introduction',
            meta: { authRequired: false },
            component: () => import('../views/pages/developer-documentation/CarsIntroduction.vue')
        },
        {
            path: 'cars/query-cars',
            name: 'query-cars',
            meta: { authRequired: false },
            component: () => import('../views/pages/developer-documentation/QueryCars.vue')
        },
        {
            path: 'stations/introduction',
            name: 'stations-introduction',
            meta: { authRequired: false },
            component: () => import('../views/pages/developer-documentation/StationsIntroduction.vue')
        },
        {
            path: 'transfers',
            name: 'transfers',
            meta: { authRequired: false },
            component: () => import('../views/pages/developer-documentation/Transfers.vue')
        },
        {
            path: 'payments',
            name: 'payments',
            meta: { authRequired: false },
            component: () => import('../views/pages/developer-documentation/Payments.vue')
        },
        {
            path: 'wallet-management',
            name: 'wallet-management',
            meta: { authRequired: false },
            component: () => import('../views/pages/developer-documentation/WalletManagement.vue')
        },
        {
            path: 'authentication',
            name: 'authentication',
            meta: { authRequired: false },
            component: () => import('../views/pages/developer-documentation/Authentication.vue')
        },
        {
            path: 'webhooks',
            name: 'webhooks',
            meta: { authRequired: false },
            component: () => import('../views/pages/developer-documentation/Webhooks.vue')
        }
    ]
},
]